import { useContext, useEffect, useState } from 'react';
import { Product, Variant } from 'shared/types/product';
import ProductTile from './ProductTile';
import { gtmViewItem } from 'helpers/utils/gtm-events/gtmEccomerce';
import { LineItemMapper } from 'helpers/utils/gtm-events/mapper/LineItemMapper';
import { useCart } from 'frontastic/hooks';
import { AccountContext } from 'context/account';
import { RouteHelpers } from 'helpers/routerHelpers';

interface Props {
  product: Product;
  onAddToCart?: () => void;
}
const ProductTileQuickView = ({ product, onAddToCart }: Props) => {
  const [selectedVariant, setSelectedVariant] = useState<Variant>();
  const { account, isResolved } = useContext(AccountContext);

  const { data: cart } = useCart();
  useEffect(() => {
    if (product && product.masterVariant) {
      setSelectedVariant(product.masterVariant);
    }
  }, [product]);

  const selectedColor = selectedVariant?.attributes?.actualColor;
  const selectedSize = selectedVariant?.attributes?.size;
  useEffect(() => {
    if (selectedVariant && isResolved) {
      gtmViewItem({
        itemDataLayer: LineItemMapper.fromProductToItemDataLayer(product, 1, selectedVariant),
        cart,
        account,
      });
    }
  }, [selectedVariant, isResolved]);

  return (
    <ProductTile
      product={product}
      selectedColor={selectedColor}
      labelSelectedColor={selectedColor}
      selectedSize={selectedSize}
      selectedVariant={selectedVariant}
      isQuickView={true}
      setSelectedVariant={(variant) => setSelectedVariant(variant)}
      onAddToCart={onAddToCart}
    />
  );
};

export default ProductTileQuickView;
